<template>
  <div class="state-dropdown-select-classification">
    <p
      v-if="title"
      class="title"
    >
      {{ title }}<span
        v-if="required"
        class="red"
      >*</span>
    </p>
    <ValidationProvider
      v-slot="{ errors }"
      class="state-dropdown-select-classification_content-wrap"
      :rules="rules"
    >
      <div
        v-click-outside="dropdownClose"
        class="state-dropdown-select-classification_content"
        :class="{outline: outline,disabled:disabled}"
      >
        <i
          v-if="leadingIcon"
          class="icon leading-icon"
          :class="leadingIcon"
        />
        <button @click="onclick()">
          <p :class="{active:value.length > 0}">
            {{ _showText }}
          </p><span v-if="_allBtnIcon === 'icon-indeterminate-check-box'">{{ value.length }}</span>
        </button>
        <i
          v-if="outline"
          class="icon trailing-icon outline icon-chevron-up"
          :class="{show: dropdown_menu_show}"
        />
        <i
          v-if="disabled"
          class="icon trailing-icon icon-chevron-down"
        />
        <i
          v-else-if="!outline && !dropdown_menu_show"
          class="icon trailing-icon icon-arrow-drop-down-circle"
        />
        <i
          v-else-if="!outline && dropdown_menu_show"
          class="icon trailing-icon icon-arrow-drop-up-circle"
        />
        <transition mode="out-in">
          <div
            v-if="dropdown_menu_show"
            class="dropdown-menu"
          >
            <div class="dropdown-scrollable-content">
              <div>
                <button @click="selectAll()">
                  <i :class="_allBtnIcon" /> {{ $t('全部') }}
                </button>
              </div>
              <perfect-scrollbar class="dropdown-scrollable-content_list ps">
                <div
                  v-for="(firstLayer,firstLayerKey) in menu"
                  :key="firstLayerKey"
                >
                  <!-- First Layer -->
                  <div
                    class="classification-title"
                    @click="onFirstLayerClick(firstLayer)"
                  >
                    <!-- <span>{{ getFirstLayerStatus(firstLayer.menu,value) }}</span> -->
                    <i :class="getFirstLayerStatus(firstLayer.menu,value)" />
                    <span>{{ firstLayer.title }}</span>
                  </div>
                  <div class="classification-subtitle">
                    <!-- Second Layer -->
                    <div
                      v-for="(secondLayer,secondLayerKey) in firstLayer.menu"
                      :key="secondLayerKey"
                    >
                      <label>
                        <input
                          type="checkbox"
                          :checked="value.includes(secondLayer.value)"
                          @change="onChange($event,secondLayer.value)"
                        >
                        <div class="checkbox-icon">
                          <i class="checked icon-check-box" />
                          <i class="unchecked icon-check-box-outline-blank" />
                        </div>
                        <span>{{ secondLayer.text }}</span>
                      </label>
                    </div>
                  </div>
                </div>
              </perfect-scrollbar>
            </div>
          </div>
        </transition>
      </div>
      <div
        v-if="errors.length > 0"
        class="invalid-text"
      >
        <i class="icon-warning invalid-icon" />
        <p
          v-for="(text,textIndex) in errors"
          :key="textIndex"
          class="text"
        >
          {{ $t(text) }}
        </p>
      </div>
      <input
        type="hidden"
        :value="value"
      >
    </ValidationProvider>
  </div>
</template>

<script>
import ClickOutside from "vue-click-outside";
import { ValidationProvider } from "vee-validate";
import { extend } from "vee-validate";
import { required } from "vee-validate/dist/rules";
extend("required", {
  ...required,
  message: "此項目為必填",
});
export default {
  name: "WsStateDropdownCheckboxLayers001",
  directives: {
    ClickOutside,
  },
  components: {
    ValidationProvider,
  },
  props: {
    menu: {
      type: Array,
      default() {
        return [];
      },
    },
    value: {
      type: Array,
      default() {
        return [];
      },
    },
    placeholder: {
      type: String,
      default() {
        return this.$t("全部");
      },
    },
    leadingIcon: {
      type: String,
      default: "",
    },
    outline: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    rules: {
      type: String,
      default: "",
    },
    required: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    dropdown_menu_show: false,
    templateContent: null,
    allBtnIcon: "icon-check-box",
  }),
  computed: {
    _showText() {
      const allValue = [];
      this.menu.forEach((menu) => {
        menu.menu.forEach((item) => {
          allValue.push(item);
        });
      });
      if (this.value.length === allValue.length) {
        return this.$t("全部");
      } else if (this.value.length == 0) {
        return this.placeholder;
      } else {
        const selectValue = [];
        allValue.forEach((value) => {
          if (this.value.indexOf(value.value) > -1) {
            selectValue.push(value);
          }
        });
        const selectValueText = selectValue.map((select) => select.text);
        return selectValueText.join("、");
      }
    },
    _allBtnIcon() {
      const allValue = [];
      this.menu.forEach((menu) => {
        menu.menu.forEach((item) => {
          allValue.push(item);
        });
      });
      if (this.value.length < allValue.length && this.value.length > 0) {
        return "icon-indeterminate-check-box";
      } else if (this.value.length === 0) {
        return "icon-check-box-outline-blank";
      }
      return "icon-check-box";
    },
  },
  methods: {
    onclick() {
      if (this.disabled) {
        return;
      }
      this.toggleDropdownMenuShow();
    },
    toggleDropdownMenuShow() {
      this.dropdown_menu_show = !this.dropdown_menu_show;
    },
    dropdownClose() {
      this.dropdown_menu_show = false;
    },
    isValueInSameLayer(value) {
      let inSameLayer = true;
      value.forEach((valueItemA) => {
        const layerTitleA = this.getLayerTitleByValue(valueItemA);
        value.forEach((valueItemB) => {
          const layerTitleB = this.getLayerTitleByValue(valueItemB);
          if (layerTitleA != layerTitleB) {
            inSameLayer = false;
          }
        });
      });
      return inSameLayer;
    },
    getLayerTitleByValue(value) {
      let title = "";
      this.menu.forEach((firstLayer) => {
        firstLayer.menu.forEach((secondLayer) => {
          if (secondLayer.value == value) {
            title = firstLayer.title;
          }
        });
      });
      return title;
    },
    findTextByValue(value) {
      let text = "";
      this.menu.forEach((firstLayer) => {
        firstLayer.menu.forEach((secondLayer) => {
          if (secondLayer.value == value) {
            text = secondLayer.text;
          }
        });
      });
      return text;
    },
    selectAll() {
      const allArr = [];
      const allValue = [];
      this.menu.forEach((menu) => {
        menu.menu.forEach((item) => {
          allValue.push(item);
        });
      });
      if (this.value.length < allValue.length) {
        this.menu.forEach((firstLayer) => {
          firstLayer.menu.forEach((secondLayer) => {
            allArr.push(secondLayer.value);
          });
        });
      }
      this.$emit("input", allArr);
      this.$emit("click");
    },
    onFirstLayerClick(firstLayer) {
      const layerStatus = this.getFirstLayerStatus(firstLayer.menu, this.value);
      const tarArr = [];
      firstLayer.menu.forEach((menuItem) => {
        tarArr.push(menuItem.value);
      });
      let newValue = JSON.parse(JSON.stringify(this.value));
      if (
        layerStatus == "icon-check-box-outline-blank" ||
        layerStatus == "icon-indeterminate-check-box"
      ) {
        newValue = newValue.concat(tarArr);
        newValue = newValue.filter(
          (item, pos) => newValue.indexOf(item) === pos
        );
      } else if (layerStatus == "icon-check-box") {
        newValue = newValue.filter((el) => {
          return !tarArr.includes(el);
        });
      }
      this.$emit("input", newValue);
      this.$emit("click");
    },
    onChange($event, value) {
      let newValue = JSON.parse(JSON.stringify(this.value));
      if ($event.target.checked) {
        if (!newValue.includes(value)) {
          newValue.push(value);
        }
      } else {
        newValue = newValue.filter((item) => item !== value);
      }
      this.$emit("input", newValue);
      this.$emit("click");
    },
    getFirstLayerStatus(layerMenu) {
      const tarArr = [];
      layerMenu.forEach((menuItem) => {
        tarArr.push(menuItem.value);
      });
      if (tarArr.every((v) => this.value.includes(v))) {
        return "icon-check-box";
      } else if (tarArr.some((r) => this.value.includes(r))) {
        return "icon-indeterminate-check-box";
      } else {
        return "icon-check-box-outline-blank";
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/component/state-dropdown-select-classification";
</style>
